import { Box, CircularProgress, Container } from "@mui/material";
import { useEffect, useState } from "react";
import BannerBlock from "../../components/BannerBlock";
import Questions360Section from "../../components/Questions360Section";
import { useParams } from "react-router-dom";
import { getAnswersByBlock360, getUserEvalInfo } from "../../axios/axiosFunctions";

const Assessment360Block = ({currentBlock,buttonsDir,changeTab,setCurrentBlock}) => {
  
  const {userEvalId,userId} = useParams();
  const [currentAnswers, setCurrentAnswers] = useState([]);
  const [userEvalInfo, setUserEvalInfo] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if(currentBlock){
      const requestAnswers = async()=>{
          const res =  await getAnswersByBlock360(currentBlock._id,userId,userEvalId);
          setCurrentAnswers(res.answers);
      }
      const callUserInfo = async()=>{
        const res = await getUserEvalInfo(userEvalId);
        setUserEvalInfo(res.user);
        setLoading(false);
      }
      callUserInfo();
      requestAnswers();
    }
  }, [currentBlock])

  return (
  <Container maxWidth="false" sx={{padding:"0px !important"}}>
      <BannerBlock name={currentBlock?.name} color={currentBlock?.color}/>
      <Box display="flex" flexDirection="column" alignItems="center">
          {
            loading && <CircularProgress/>
          }
          {
            !loading &&
            <Questions360Section blockId={currentBlock._id} questions={currentBlock?.questions} color={currentBlock?.color} buttonsDir={buttonsDir} changeTab={changeTab} setCurrentBlock={setCurrentBlock} 
            currentAnswers={currentAnswers} setCurrentAnswers={setCurrentAnswers} userEvalInfo={userEvalInfo}/>
          }
      </Box>
  </Container>
)
}

export default Assessment360Block